import { render, staticRenderFns } from "./_live22.vue?vue&type=template&id=390dde7b&scoped=true&lang=pug&"
import script from "./_live22.vue?vue&type=script&lang=js&"
export * from "./_live22.vue?vue&type=script&lang=js&"
import style0 from "./_live22.vue?vue&type=style&index=0&id=390dde7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390dde7b",
  null
  
)

export default component.exports